import styled from 'styled-components';
import { colors } from '@/constants';

export const ButtonToTopWrapper = styled.div<{ $isVisible: boolean }>`
  z-index: 1000;
  border-radius: 50%;
  background-color: ${colors.brand.grafite};
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: ${(i) => (i.$isVisible ? 1 : 0)};
  visibility: ${(i) => (i.$isVisible ? 'visible' : 'hidden')};
  box-shadow: 0px 4px 15px 0px ${colors.gray.gray20 + '88'};
  transition:
    opacity 0.3s ease-in-out,
    visibility 0.3s ease-in-out;
  svg {
    font-size: 20px;
    color: ${colors.brand.white};
  }
`;
